import { Injectable } from '@angular/core';
import { API } from '@core/services/api.base';
import { Observable } from 'rxjs';
import { StaffEntity } from 'src/app/models/staff.model';

@Injectable({
  providedIn: 'root',
})
export class StaffService extends API {
  /**
   * Get all staff members for a store
   */
  getStaffByStoreId(storeId: string): Observable<StaffEntity[]> {
    return this.get<StaffEntity[]>(`v1/staff?storeId=${storeId}`);
  }

  /**
   * Get a specific staff member by ID
   */
  getStaffById(staffId: string): Observable<StaffEntity> {
    return this.get<StaffEntity>(`v1/staff/${staffId}`);
  }
}

